import { useGetForeignCurrencyRates } from '@/context/services/foreign_currency/Detail/ApCurrencyRates.service';
import { ApPayeeDetail as ApPayeeModel } from 'ap-openapi';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { usePayee, useSetPayee } from './context';
import { ForeignCurrency } from './type';
export const useUpdateSelectedApPayee = () => {
  const update = useSetPayee();
  return useCallback(
    (newValue: ApPayeeModel | undefined) => {
      update(newValue);
    },
    [update]
  );
};

export const useSelectedApPayee = () => {
  return usePayee();
};

export const useSelectedApPayeeForeignCurrency = (): ForeignCurrency => {
  const payee = useSelectedApPayee();
  const [defaultCurrency, setDefaultCurrency] = useState('JPY');
  const { data, isLoading } = useGetForeignCurrencyRates({
    currency: defaultCurrency,
    transactionDate: payee?.book_date,
    onPageChange: () => {},
  });
  useEffect(() => {
    setDefaultCurrency(payee?.foreign_currency?.currency ?? 'JPY');
  }, [payee?.foreign_currency?.currency]);
  return useMemo(() => {
    const foreignCurrency = payee?.foreign_currency;
    if (!foreignCurrency)
      return {
        currency: 'JPY',
        rate: 1,
        isLoading: false,
      };

    return {
      currency: foreignCurrency.currency!,
      rate:
        payee.foreign_currency?.currency === 'JPY' ? 1 : data?.[0]?.value ?? 1,
      isLoading: isLoading,
    };
  }, [data, isLoading, payee?.foreign_currency]);
};
